import DashboardTwoToneIcon from '@material-ui/icons/DashboardTwoTone';
import HelpOutline from '@material-ui/icons/HelpOutline';
import {LogoutIcon} from '../../elements/svgIcons'

const iconsMap: {
    [key: string]: any
} = {
    DashboardTwoToneIcon: DashboardTwoToneIcon,
    LogoutIcon: LogoutIcon,
    HelpOutline: HelpOutline,

};


export default [
    {
        "label": "Home",
        "icon": iconsMap["DashboardTwoToneIcon"],
        "to": "/dashboard"
    },
    {
        "label": "Help",
        "icon": iconsMap["HelpOutline"],
        "to": "/faq"
    },
    {
        "label": "Log Out",
        "icon": iconsMap["LogoutIcon"],
        "to": "logout",
        "className": "logout-icon"
    }
]
